// All values below are PLACEHOLDERS until RR&B provides final information.
export const BUSINESS = {
  name: "RR&B 24 Hour Daycare",
  city: "Dallas, TX",
  phone: null,
  phoneDisplay: "(000) 000-0000",
  phonePlaceholder: true,
  address: "Address coming soon",
  hours: "Hours wording coming soon",
  serviceArea: "Service area coming soon",
};
